/**
 *
 *
 */
export const CLOSE_BUTTON = "close-button";

/**
 *
 *
 */
export const BACK_BUTTON = "back-button";

/**
 *
 *
 */
export const BACK_DROP = "back-drop";

/**
 *
 *
 *
 *
 */
export const DRAG_DOWN = "drag-down";

/**
 *
 *
 *
 */
export const ESCAPE_KEY = "escape-key";

/**
 *
 *
 *
 *
 */
export const PROGRAMMATICALLY = "programmatically";

/**
 *
 *
 *
 */
export const USER_AGENT = "user-agent";

/**
 *
 *
 *
 */
export const PAGE_ENTRY_URL = "page-entry-url";
